export const types = {
  SETTINGS_SAVE: "SETTINGS_SAVE",
  SETTINGS_SAVE_SUCCESS: "SETTINGS_SAVE_SUCCESS",
  SETTINGS_SAVE_ERROR: "SETTINGS_SAVE_ERROR",
  SETTINGS_LOAD: "SETTINGS_LOAD",
  SETTINGS_LOAD_SUCCESS: "SETTINGS_LOAD_SUCCESS",
  SETTINGS_LOAD_ERROR: "SETTINGS_LOAD_ERROR",
};
